
export default {
  name: 'TPOk',
  props: {
    width: {
      type: Number,
      default: 31
    },
    height: {
      type: Number,
      default: 31
    }
  }
}
